// Rótulos normativos da ficha `inspection-v1` (form §7.3).
// Namespace `inspection.catalog.v1.*` — cada versão tem o próprio subtree.

export const inspectionCatalogV1EnUS = {
  common: {
    yes: "Yes",
    no: "No",
    na: "N/A",
    notApplicable: "Not applicable",
    good: "Good",
    regular: "Fair",
    deficient: "Poor",
    observations: "Observations",
    photos: "Photos",
    others: "Others (identify)",
    describe: "Describe",
    local: "Location",
    note: "Note",
    type: "Type",
    value: "Value",
    flowRate: "Flow rate",
    elevationM: "Elev. (m)",
    lengthM: "Length (m)",
    openingMm: "Aperture (mm)",
    orientation: "Orientation",
    manifestation: "Manifestation",
    solidCarryover: "Visible solids transport",
    cleaningState: "Cleanliness condition",
    structuralCondition: "Structural condition",
    structuralConditions: "Structural conditions",
    addCrack: "Add crack",
    addSettlement: "Add settlement",
    addSeepage: "Add seepage",
    addErosion: "Add erosion",
    addLine: "Add line",
    addOccurrence: "Add occurrence",
  },
  choices: {
    longitudinal: "Longitudinal",
    transversal: "Transverse",
    crest: "Crest",
    berms: "Berms",
    slopes: "Slopes",
    depression: "Depression / Slump",
    settlement: "Settlement",
    grassNeedsPruning: "Grass requiring mowing",
    controlledOrAbsentDuringRaising: "Controlled / Absent during raising",
    shrubOrTreeVegetation: "Shrub and/or tree vegetation",
    absentWithoutRaising: "Absent with no raising",
  },
  placeholders: {
    local: "reach, coordinate, station…",
    othersDescribe: "Identify the residual finding…",
    othersObservations: "Additional observations…",
    lengthExample: "E.g.: 3,20",
    openingExample: "E.g.: 5",
    flowValue: "Value and unit (e.g.: 0,5 L/s)",
    elevation: "Elevation (m)…",
    beachLength: "E.g.: 15,00 m…",
    flowRate: "Flow rate:…",
  },
  steps: {
    generalData: "General data",
    accesses: "Access condition",
    damBody: "Dam body / Abutments",
    reservoir: "Reservoir",
    spillway: "Spillway(s)",
    instrumentation: "Instrumentation (physical integrity, identification, access)",
    beachCondition: "Beach condition",
    tailingsWaterIntake: "Tailings pipelines / Water intake",
    conservationState: "Conservation state",
    generalComments: "General comments",
    signatures: "Signatures",
  },
  stepShort: {
    accesses: "Accesses",
    damBody: "Dam body",
    reservoir: "Reservoir",
    spillway: "Spillway",
    instrumentation: "Instrumentation",
    beachCondition: "Beach condition",
    tailingsWaterIntake: "Pipelines / Intake",
  },
  sections: {
    pests: "Presence of insects / animals",
    internalDrainage: "Internal drainage",
    geomembraneOccurrences: "Geomembrane occurrences",
  },
  occurrence: {
    crack: "Crack",
    settlement: "Settlement",
    seepage: "Seepage",
    erosion: "Erosion",
    geomembrane: "Geomembrane",
  },
  items: {
    accesses: {
      generalConservation: "General conservation",
      slopes: "Slopes",
      floorPavement: "Pavement surfacing",
      drainageDevices: "Drainage devices",
    },
    damBody: {
      cracksIdentified: "Identified cracks",
      settlementsIdentified: "Identified settlements",
      seepagesIdentified: "Identified seepage(s)",
      surfaceErosions: "Surface erosions",
      surfaceDrainage: "Surface drainage",
      drainageChannel: "Drainage channel",
      vegetalCover: "Vegetative cover",
      pests: {
        termitesRodents: "Anthills / Termites / Rodents",
        animals: "Animals (check tracks / droppings)",
        burrows: "Presence of burrows or holes",
      },
      internalDrainage: {
        outletSilting: "Siltation of the drain/colloid outlet",
        solidCarryover: "Visible solids transport",
        flowChange: "Significant change in flow rate",
        drainSaturation: "Saturation around the drain",
        flowMeterOperational: "Flow meter operational",
        flowMeasured: "Internal drainage flow rate measured during the inspection",
      },
      complementaryStructures: "Ancillary structures",
      reinforcement:
        "Reinforcement structure (buttressing, stability berm, etc.)",
      saddleDike: "Saddle dike",
      sump: "Sump associated with the structure",
    },
    reservoir: {
      bankCondition: "Bank condition (erosions or instability processes)",
      impermeabilized: "Lined reservoir",
      geomembraneConservation: "Geomembrane conservation state",
      operationalFreeboard: "Operational freeboard",
    },
    spillway: {
      type: "Spillway type",
      inletSectionCondition: "Inlet section condition",
      outletSectionCondition: "Outlet section condition",
      stillingBasinCondition: "Stilling basin condition",
      structuralCondition: "Structural condition",
      hasEmergencySpillway: "Has emergency spillway?",
    },
    instrumentation: {
      access: "Access to instruments",
      protection: "Instrument protection",
      conservationState: "Conservation state",
      localGaugesCondition:
        "Condition of local gauges (staff gauge, rain-gauge graduation, buckets, tape with sonic sensor)",
      identification: "Instrument identification",
    },
    beachCondition: {
      tailingsDisposal: "Tailings disposal/management in the reservoir",
      safeWaterDistance: "Safe distance from the water surface to the crest",
      physicalSignaling: "Operational condition of physical markers (drums)",
      beachLengthVsCrest: "Beach length relative to the crest (if applicable)",
    },
    tailingsWaterIntake: {
      tailingsInflow: "Is tailings inflow into the reservoir occurring?",
      tailingsLineLeak: "Does the tailings line show signs of leakage?",
      waterPumpingActive:
        "Is water being pumped from the reservoir? Indicate if it is active",
      waterPipeLeak: "Does the water pipeline show signs of leakage?",
      intakeOperating: "Is the intake system operating normally? Flow rate:",
      bargeAccessOperating: 'Is access to the floating intake ("barge") operating?',
    },
  },
} as const;
